<div class="row mb-5 ml-2" style="margin-top:2%">
    <style>.label-large {
        font-weight: bold;
    }</style>
    <div class="col-md-12 mb-2">
        <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" id="totalCheckbox"  [(ngModel)]="showTotals">
            <label class="custom-control-label" for="totalCheckbox">
                Afficher les montants totaux
            </label>
        </div>
    </div>

    <div class="col-md-12 mb-2">
        <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" id="contactCheckbox" [(ngModel)]="showContactInfo">
            <label class="custom-control-label" for="contactCheckbox">
                Afficher les informations de contact
            </label>
        </div>
    </div>

    <div class="col-md-12 mb-2">
        <div class="custom-control custom-checkbox">
            <input class="custom-control-input" type="checkbox" id="descCheckbox" [(ngModel)]="showDescription">
            <label class="custom-control-label" for="descCheckbox">
                Afficher une courte description
            </label>
        </div>
    </div>
    <div class="col-md-4 mb-2">
        <hr>
    </div>
    <div class="col-md-12 mb-2">
        <label class="form-check-label label-large" for="descCheckbox">
            Note
        </label>
        <textarea class="form-control note" name="noteCf" [(ngModel)]="noteText" placeholder="Saisissez une note" style="width:85%"></textarea>
    </div>
</div>


<div class="d-flex justify-content-end align-items-center flex-wrap w-100 position-fixed-bottom mt-2 mb-2">
    <a class="btn btn-grey waves-effect m-1" routerLink="/main/parametre/document">Annuler</a>
    <button type="button" class="btn btn-green waves-effect m-1" (click)="appercue()">Aperçu de la configuration</button>
    <button type="button" class="btn btn-primary waves-effect m-1" (click)="saveParametreDocument()" [disabled]="saving">{{ saving ? 'Enregistrement…' : 'Enregistrer' }}</button>
</div>
